<template>
  <div class="d-inline-block">
    <span v-if="!isTruncate" class="body-2 font-weight-medium">{{ text }}</span>
    <v-tooltip v-else top>
      <template #activator="{ on, attrs }">
        <span v-bind="attrs" class="d-inline-block body-2 font-weight-medium" :class="applyClass" v-on="on">
          {{ truncateText(text) }}
        </span>
      </template>
      <span>{{ text }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'TruncateText',

  props: {
    text: {
      type: String,
      default: ''
    },
    maxChar: {
      type: Number,
      default: 25
    },
    applyClass: {
      type: String,
      default: ''
    }
  },

  computed: {
    isTruncate() {
      return this.text.length > this.maxChar
    }
  },

  methods: {
    truncateText() {
      return this.text.substring(0, this.maxChar) + '…'
    }
  }
}
</script>

<style>
</style>
